var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"国际套餐","name":"first"}},[_c('InternationalProduct')],1),_c('el-tab-pane',{attrs:{"label":"国际接口套餐","name":"third"}},[_c('ExternalInternationalProduct')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }